module.exports = __webpack_public_path__ + "img/picture_changsha.6b00442b.jpg";